import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUsersPage from '@features/user/pages/EntityUsersPage';

const DistrictUsersPage: React.FC = () => {
  const { districtId } = useParams<{ districtId: string }>();
  return (
    <EntityUsersPage
      scope="DISTRICT"
      scopeRefId={Number(districtId)}
      title="District - Users"
      subtitle="People with roles at this district"
      testId="district-users-search"
    />
  );
};

export default DistrictUsersPage;
